module.exports = __webpack_public_path__ + "img/01.856ab9bb.jpg";